import copy from "copy-to-clipboard"
import toast from "react-hot-toast"
import { FullInfluencerFragment } from "~/__generated__/graphql"
import { Button } from "~/shadcn/ui/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "~/shadcn/ui/tooltip"
import { publicInfluencerMediaKitPath } from "~/common/paths"
import { trackEvent } from "~/util/tracking"

import MediaKitIcon from "~/images/icons/media-kit.svg?react"

// Why a creator's media kit link wouldn't open for a visitor, or null when it
// would. Mirrors Influencer.publicly_viewable (ZAN-902).
const unavailableReason = (
  influencer: FullInfluencerFragment
): string | null => {
  if (!influencer.agency?.publiclyViewable)
    return "This agency's media kit isn't published."
  if (influencer.deleted) return "This creator has been deleted."
  if (!influencer.visible)
    return "Hidden creators don't have a public media kit."
  return null
}

export const MediaKitButton = ({
  influencer,
}: {
  influencer: FullInfluencerFragment
}) => {
  const reason = unavailableReason(influencer)

  if (reason !== null) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          {/* A disabled button gets no pointer or focus events, so the
              wrapper carries the tooltip. */}
          <span tabIndex={0} aria-label={`Media Kit: ${reason}`}>
            <Button
              variant="ghost"
              disabled
              className="px-4 flex flex-row gap-2"
            >
              <MediaKitIcon />
              <span>Media Kit</span>
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{reason}</p>
        </TooltipContent>
      </Tooltip>
    )
  }

  return (
    <Button
      variant="ghost"
      onClick={(e) => {
        e.stopPropagation()
        const url = `${window.location.origin}${publicInfluencerMediaKitPath({
          agencySlug: influencer.agency?.slug ?? "",
          influencerSlug: influencer.slug,
        })}`
        copy(url)
        trackEvent("copy_media_kit_link", { influencerId: influencer.id ?? "" })
        toast.success(`Copied URL to clipboard`)
      }}
      className="px-4 flex flex-row gap-2"
    >
      <MediaKitIcon />
      <span>Media Kit</span>
    </Button>
  )
}
